const methods = {
    async createFusion(payload) {
        this.loading = true;
        this.$root.$emit('showModalWarningAction', false);
        try {
            const payloadFusion = {
                match: true,
                uuid_daily_summary: payload.actionData.uuid_daily_summary,
                uuid_mismatched_operation: payload.actionData.uuid_mismatched_operation,
                nav: payload.nav,
                key_product: payload.key_product,
                key_operation_type: payload.key_operation_type,
                shares: payload.shares,
                withholding: payload.withholding,
                commission: payload.commission,
                gross_amount: payload.gross_amount,
                net_amount: payload.net_amount
            };
            await this.$operationsService.updateOperation(payload.actionData.uuid, payloadFusion);
            this.$toast.success(`Fusión realizada`, `La operación se ha fusionado con éxito.`);
            this.loading = false;
        } catch (error) {
            this.$toast.error(`Fusión fallida`, `No se ha podido fusionar la operación.`);
        }
    },

    async addOperation(payload) {
        this.loading = true;
        this.$root.$emit('showModalWarningAction', false);
        try {
            const payloadAdd = {
                match: true,
                uuid_daily_summary: payload.actionData.uuid_daily_summary,
                uuid_mismatched_operation: payload.actionData.uuid_mismatched_operation,
                source: 'ONLINE',
                ...payload.rd_operation,
                uuid_account: payload.actionData.uuid_account
            };
            await this.$operationsService.createOperation(payloadAdd);
            this.$toast.success(`Operación añadida`, `La operación se ha añadido con éxito.`);
            this.keyUpdate++;
        } catch (error) {
            this.$toast.error(`Operación fallida`, `No se ha podido crear la operación.`);
        }
    },

    cancelFusionAction() {
        this.checksActivated = false;
        this.itemsToFusionFromLastMovements = [];
    },

    // fusionamos una operación con X movimientos
    async createOperationsBulk() {
        const operationsBulk = this.itemsToFusionFromLastMovements.map(movement => {
            return {
                source: 'ONLINE',
                uuid_daily_summary: this.operationToFusionWithMovements.uuid_daily_summary,
                match: true,
                uuid_mismatched_operation: this.operationToFusionWithMovements.uuid,
                ...this.operationToFusionWithMovements.rd_operation,
                uuid: movement.uuid
            };
        });
        try {
            await this.$operationsService.createOperationsBulk({ operations: operationsBulk });
            this.keyUpdate++;
            this.checksActivated = false;
            this.$toast.success('OK', 'Fusión realizada con éxito');
        } catch (error) {
            this.checksActivated = false;
            this.$toast.error('Error', error);
        }
    }
};

export default methods;
